module.exports = __webpack_public_path__ + "static/media/VestasSans-Heavy.9035a19e.svg";